.SectionIntro {
  display: flex;
  flex-direction: column;
  gap: var(--base-size-16);
  align-items: flex-start;
  padding-block: var(--base-size-24);
}

.SectionIntro :is(img, picture) {
  display: block;
}

.SectionIntro-heading--muted {
  color: var(--brand-color-text-muted);
}

.SectionIntro-heading--muted em,
.SectionIntro-heading--muted b {
  color: var(--brand-color-text-default);
  font-style: normal;
  font-weight: inherit;
}

.SectionIntro--align-start {
  text-align: start;
}

.SectionIntro--align-center {
  align-items: center;
  text-align: center;
  padding-inline: var(--base-size-24);
}

.SectionIntro-heading {
  max-width: 24ch;
}

.SectionIntro--full-width .SectionIntro-heading {
  max-width: none;
}

.SectionIntro-label {
  margin-block-end: var(--base-size-2);
}

.SectionIntro-description {
  padding-block-start: var(--base-size-2);
  max-width: 50ch;
}

.SectionIntro-link {
  margin-top: var(--base-size-16);
}
